<div
  [class.focused]="focused"
  [class.checked]="checked || indeterminateState"
  [class.disabled]="disabled"
  [class.visible-label]="disabled && fadeOnlyCheckbox"
  [class.rtl]="direction === 'rtl'"
  [class.ltr]="direction === 'ltr'"
  [class.is-toggle]="mode === 'toggle'"
  [class.weight-semi-bold]="isWeightSemiBold"
  [class.only-icon-clickable]="changeOnlyOnIconClick"
  class="checkbox-wrapper"
>
  <ng-template [ngIf]="mode === 'checkbox'">
    <div #checkboxIconEl class="checkbox-container">
      <div
        [class.orange]="orangeCheck"
        [class.violet]="violetCheck"
        [class.grey]="greyCheck"
        class="check"
      >
        <ng-container *ngIf="!indeterminateState; else indeterminateStateTpl">
          <rt-icon name="check"></rt-icon>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="mode === 'toggle'">
    <div #toggleIconEl class="toggle-container" [class.no-label]="noLabel">
      <div [class.is-animated]="animated" class="toggle-knob"></div>
      <rt-icon name="check" size="small-x" class="toggle-icon"></rt-icon>
    </div>
  </ng-template>

  <div [class]="labelClass">
    <!-- TODO replace this with `label: string` and `labelTemplate: TemplateRef` props -->
    <ng-content></ng-content>
  </div>

  <input
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    [readOnly]="readOnly"
    (change)="handleChange(!$any($event.target).checked ? value || true : false)"
    class="visually-hidden"
    type="checkbox"
  />
</div>

<ng-template #indeterminateStateTpl>
  <div class="indeterminate-state-symbol"></div>
</ng-template>
